import { Skeleton } from 'antd';

import './UserDetailsSkeleton.scss';

const CONTACT_ROWS_COUNT = 4;
const SOURCE_ROWS_COUNT = 4;
const ACTION_ROWS_COUNT = 3;
const TAGS_WIDTHS = [60, 90, 70, 110];
const QUICK_ACTIONS_COUNT = 5;

export const UserDetailsSkeleton = () => (
  <div className="UserDetailsSkeleton" aria-busy="true" aria-live="polite">
    <div className="UserDetailsSkeleton__header">
      <Skeleton.Avatar active size={36} shape="circle" />
      <Skeleton.Input
        className="UserDetailsSkeleton__name"
        active
        size="default"
      />
      <div className="UserDetailsSkeleton__header-actions">
        <Skeleton.Button active size="small" shape="square" />
        <Skeleton.Button active size="small" shape="square" />
      </div>
    </div>

    <div className="UserDetailsSkeleton__scroll">
      <section className="UserDetailsSkeleton__section">
        <Skeleton.Input
          className="UserDetailsSkeleton__section-title"
          active
          size="small"
        />
        <div className="UserDetailsSkeleton__contacts">
          {Array.from({ length: CONTACT_ROWS_COUNT }, (_, index) => (
            <div className="UserDetailsSkeleton__contact-row" key={index}>
              <Skeleton.Avatar active size={22} shape="square" />
              <Skeleton.Input active size="small" block />
            </div>
          ))}
        </div>
      </section>

      <section className="UserDetailsSkeleton__section">
        <Skeleton.Input
          className="UserDetailsSkeleton__section-title"
          active
          size="small"
        />
        <Skeleton.Input
          className="UserDetailsSkeleton__select"
          active
          size="default"
          block
        />
      </section>

      <section className="UserDetailsSkeleton__section">
        <Skeleton.Input
          className="UserDetailsSkeleton__section-title"
          active
          size="small"
        />
        <Skeleton.Button
          className="UserDetailsSkeleton__funnel"
          active
          size="large"
          block
        />
      </section>

      <section className="UserDetailsSkeleton__section">
        <div className="UserDetailsSkeleton__section-header">
          <Skeleton.Input
            className="UserDetailsSkeleton__section-title"
            active
            size="small"
          />
          <div className="UserDetailsSkeleton__section-controls">
            <Skeleton.Button active size="small" />
            <Skeleton.Button active size="small" />
          </div>
        </div>
        <div className="UserDetailsSkeleton__checkbox-list">
          {Array.from({ length: SOURCE_ROWS_COUNT }, (_, index) => (
            <div className="UserDetailsSkeleton__checkbox-row" key={index}>
              <Skeleton.Avatar active size={16} shape="square" />
              <Skeleton.Input active size="small" block />
            </div>
          ))}
        </div>
      </section>

      <section className="UserDetailsSkeleton__section">
        <div className="UserDetailsSkeleton__section-header">
          <Skeleton.Input
            className="UserDetailsSkeleton__section-title"
            active
            size="small"
          />
          <div className="UserDetailsSkeleton__section-controls">
            <Skeleton.Button active size="small" />
            <Skeleton.Button active size="small" />
          </div>
        </div>
        <div className="UserDetailsSkeleton__checkbox-list">
          {Array.from({ length: ACTION_ROWS_COUNT }, (_, index) => (
            <div className="UserDetailsSkeleton__checkbox-row" key={index}>
              <Skeleton.Avatar active size={16} shape="square" />
              <Skeleton.Input active size="small" block />
            </div>
          ))}
        </div>
      </section>

      <section className="UserDetailsSkeleton__section">
        <Skeleton.Input
          className="UserDetailsSkeleton__section-title"
          active
          size="small"
        />
        <div className="UserDetailsSkeleton__tags">
          {TAGS_WIDTHS.map((width, index) => (
            <Skeleton.Button
              className="UserDetailsSkeleton__tag"
              active
              size="small"
              style={{ width }}
              key={index}
            />
          ))}
        </div>
      </section>
    </div>

    <div className="UserDetailsSkeleton__footer">
      {Array.from({ length: QUICK_ACTIONS_COUNT }, (_, index) => (
        <Skeleton.Button
          className="UserDetailsSkeleton__quick-action"
          active
          size="default"
          block
          key={index}
        />
      ))}
    </div>
  </div>
);
